import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Trails = () => {
  return (
    <>
      <Navbar />

      {/* Page Banner */}
      <section
        className="page-banner"
        style={{ backgroundImage: 'url("/assets/images/hero.jpg")' }}
      >
        <div className="overlay"></div>
        <div className="banner-content container">
          <h1>Explore Trails</h1>
          <p>Discover the most breathtaking trails in British Columbia.</p>
        </div>
      </section>

      {/* Main Content */}
      <main>
        <section className="trails container">
          <h2>Top 10 Trails in British Columbia</h2>
          <div className="trail-list">
            {/* Trail 1: Grouse Grind */}
            <div className="trail-item">
              <img src="/assets/images/grouse-mountain.jpg" alt="Grouse Grind" />
              <h3>Grouse Grind</h3>
              <p>
                Known as "Mother Nature's Stairmaster," Grouse Grind is a challenging
                climb offering breathtaking views at the summit.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/grouse-grind/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/grouse-grind"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 2: Saint Mark's Summit */}
            <div className="trail-item">
              <img src="/assets/images/saint-marks-summit.jpg" alt="Saint Mark's Summit" />
              <h3>Saint Mark's Summit</h3>
              <p>
                This moderately difficult trail offers panoramic views of Howe Sound
                and the surrounding islands from the summit.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/saint-marks-summit/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/saint-marks-summit"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 3: Lighthouse Park */}
            <div className="trail-item">
              <img src="/assets/images/light-house.jpg" alt="Lighthouse Park" />
              <h3>Lighthouse Park</h3>
              <p>
                Located in West Vancouver, this easy hike offers stunning ocean views
                and a historic lighthouse in a beautiful forest setting.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/lighthouse-park/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/lighthouse-park"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 4: Norvan Falls */}
            <div className="trail-item">
              <img src="/assets/images/norvan-falls.jpg" alt="Norvan Falls" />
              <h3>Norvan Falls</h3>
              <p>
                This scenic trail leads you to the picturesque Norvan Falls, a beautiful
                waterfall located in the lush Lynn Headwaters Regional Park.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/norvan-falls/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/norvan-falls"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 5: Deep Cove to Lynn Canyon (Baden Powell Trail) */}
            <div className="trail-item">
              <img src="/assets/images/lynn-canyon.jpg" alt="Deep Cove to Lynn Canyon" />
              <h3>Deep Cove to Lynn Canyon</h3>
              <p>
                Hike a section of the Baden Powell Trail from Deep Cove to Lynn Canyon,
                passing through forests and over suspension bridges.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/baden-powell-deep-cove-to-lynn-canyon/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/baden-powell-trail-horseshoe-bay-deep-cove"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 6: Garibaldi Lake Trail */}
            <div className="trail-item">
              <img src="/assets/images/garibaldi-trail.jpg" alt="Garibaldi Lake Trail" />
              <h3>Garibaldi Lake Trail</h3>
              <p>
                A scenic hike leading to the turquoise waters of Garibaldi Lake,
                surrounded by snow-capped mountains.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/garibaldi-lake/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/garibaldi-lake"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 7: Juan de Fuca Marine Trail */}
            <div className="trail-item">
              <img src="/assets/images/juan-de-fuca.jpg" alt="Juan de Fuca Marine Trail" />
              <h3>Juan de Fuca Marine Trail</h3>
              <p>
                An adventurous coastal trail offering stunning ocean views, beaches,
                and rainforest scenery.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouverisland.com/parks/?id=463"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Island
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/juan-de-fuca-marine-trail"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 8: West Coast Trail */}
            <div className="trail-item">
              <img src="/assets/images/west-coast.jpg" alt="West Coast Trail" />
              <h3>West Coast Trail</h3>
              <p>
                A challenging multi-day hike along the rugged west coast, rich in history
                and natural beauty.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.pc.gc.ca/en/pn-np/bc/pacificrim/activ/activ6a"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Parks Canada
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/west-coast-trail"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 9: Joffre Lakes Trail */}
            <div className="trail-item">
              <img src="/assets/images/joffre-lakes.jpg" alt="Joffre Lakes Trail" />
              <h3>Joffre Lakes Trail</h3>
              <p>
                Experience three stunning glacier-fed lakes with vibrant blue waters in this
                popular hike.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/joffre-lakes/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/joffre-lakes"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>

            {/* Trail 10: Stawamus Chief Trail */}
            <div className="trail-item">
              <img src="/assets/images/stawamus-chief.jpg" alt="Stawamus Chief Trail" />
              <h3>Stawamus Chief Trail</h3>
              <p>
                Climb one of North America's largest granite monoliths for panoramic views
                of Howe Sound.
              </p>
              <div className="trail-buttons">
                <a
                  href="https://www.vancouvertrails.com/trails/stawamus-chief/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  Vancouver Trails
                </a>
                <a
                  href="https://www.alltrails.com/trail/canada/british-columbia/stawamus-chief"
                  target="_blank"
                  rel="noreferrer"
                  className="btn"
                >
                  AllTrails
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Trails;